import { Card, Row, Table } from "antd";
import { useFetchData } from "../../../../../../../../lib/hooks/useDefaultFetchData";
import PayersService from "../../../../../../../../services/accounts/payers";
import { IPayersGet } from "../../../../../../../../types/Payer";
import { useGetTableColumns } from "./hooks/useGetTableColumns";
import { Loader } from "../../../../../../../../components/Loader";
import { useCallback, useMemo, useState } from "react";
import { createPortal } from "react-dom";
import { useOpenSidebar } from "./hooks/useOpenSidebar";
import { useDefualtOnRow } from "../../../../../../../../lib/hooks/useDefaultOnRow";
import { Header } from "./components/Header";
import { useNoCountPaginationProps } from "../../../../../../../../lib/hooks/useNoCountPaginationProps";
import "./styles.scss";

type TPayerProps = {
  contractId: string;
  primaryBuyerNumber: number;
};

type TRequest = {
  contractId: string;
};

export const Payers = ({ contractId, primaryBuyerNumber }: TPayerProps) => {
  const [id, setId] = useState<string | null | undefined>(undefined);

  const request = useMemo(() => ({ contractId }), [contractId]);

  const { data, isLoading, fetchData } = useFetchData<TRequest, IPayersGet>(
    PayersService,
    request,
  );

  const total: number = useMemo(() => data.length, [data]);

  const { paginationProps } = useNoCountPaginationProps(total);

  const { formWrapper } = useOpenSidebar({
    id,
    setId,
    fetchData,
    primaryBuyerNumber,
    parentId: contractId,
  });

  const { columns } = useGetTableColumns({ fetchData, setId });

  const rowClassName = useCallback(
    (record: IPayersGet): string => (record.status === 1 ? "gray-row" : ""),
    [],
  );

  const onAddClick = useCallback(() => setId(null), [setId]);

  const { onRow } = useDefualtOnRow(setId);

  return (
    <Row className="w-100 mb-4">
      <Card className="w-100">
        <Header data={data} isLoading={isLoading} onAddClick={onAddClick} />
        {isLoading ? (
          <Loader fontSize="64px" />
        ) : (
          data.length !== 0 && (
            <Row className="d-block">
              <Table
                dataSource={data}
                columns={columns}
                pagination={paginationProps}
                rowKey="id"
                className="w-100 clickable-rows-table small-table"
                rowClassName={rowClassName}
                onRow={onRow}
              />
            </Row>
          )
        )}
      </Card>
      {id !== undefined && createPortal(formWrapper, document.body)}
    </Row>
  );
};
